import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { themeStyle, themeStyleDark } from "../components/Components";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import {
  ContentSideBySide,
  ContentSideBySideInv,
  ThreeSideBySide,
  Hero,
  Gallery,
  Stats,
  SpacerV,
} from "../components/Hero";
import { API_URL } from "../actions/auth";
import axios from "axios";
import { useNavigate } from "react-router";
import { TypeAnimation } from "react-type-animation";
import Lottie from "react-lottie";
import {
  OurProcess,
  Advantages,
  YouWillGet,
  Collage,
  FAQ2,
  Collage2,
  Trust,
  Tailor,
} from "../components/Sections";
import { layout } from "../components/Layout";

export default function PayPerClick() {
  const [news, setNews] = useState([]);
  const navigate = useNavigate();
  const state = useSelector((state) => state);
  const dark = false;
  function getContent() {
    return (
      <div className="main">
        <Sidebar />
        <div
          className="anigrad"
          style={{ backgroundColor: dark ? "#111" : "white" }}
        >
          <div
            style={{
              height: state.auth.isMobile ? "130vh" : "100vh",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              width: "100vw",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                width: "75vw",
              }}
            >
              <div
                style={{
                  marginTop: state.auth.isMobile
                    ? state.auth.isTablet
                      ? "-300px"
                      : "-135px"
                    : "0px",
                  fontSize: state.auth.isMobile ? "25px" : "6vh",
                  color: "white",
                  zIndex: 999,
                  textAlign: "left",
                  marginBottom: "25px",
                  fontWeight: "bold",
                }}
              >
                <div
                  style={{
                    fontSize: layout.heading2[state.auth.view],
                  }}
                >
                  Maximize ROI with Our Expert PPC Agency Services
                </div>
              </div>
              <div
                style={{
                  fontSize: layout.textMedium[state.auth.view],
                  color: "white",
                  zIndex: 999,
                  textAlign: "left",
                }}
              >
                We execute Pay-Per-Click (PPC) campaigns with precision to
                generate high-quality traffic and conversions. Our strategic
                bidding and targeted placements help businesses achieve maximum
                return on ad spend.
              </div>
              <button
                style={{
                  marginTop: "6vh",
                  filter: dark ? "invert(0)" : "invert(1)",
                }}
                onClick={() => {
                  navigate("/get-a-quote/");
                }}
                className="squishy"
              >
                Request a free estimate
              </button>
              <div
                style={{
                  display:
                    state.auth.isMobile || state.auth.view == "TABP"
                      ? "none"
                      : "block",
                }}
              >
                <Tailor
                  invert
                  title1="Custom Solutions"
                  subtitle1="Tailored for your unique brand."
                  title2="Results-Driven"
                  subtitle2="Designed to achieve business success."
                  title3="User-Friendly"
                  subtitle3="Simplify edits with ease."
                />
              </div>
            </div>
          </div>
          <Stats />
          {state.auth.isTablet ? (
            <SpacerV height={"300px"} background="#111" />
          ) : (
            ""
          )}
          <ContentSideBySide
            dark={dark}
            title={<h2>Profit-Driven Pay-Per-Click Solutions</h2>}
            subtitle={
              <div>
                At Riches Media Digital, we specialize in high-performance PPC
                campaigns that drive measurable business outcomes.
                <br />
                <ul>
                  {" "}
                  <li>
                    <b>
                      Our team develops tailored strategies that focus on
                      cost-efficient bidding and audience targeting to deliver
                      immediate, high-intent traffic.{" "}
                    </b>
                  </li>
                  <li>
                    <b>
                      Every campaign is optimized for click-through rates and
                      conversions to increase revenue.
                    </b>
                  </li>
                </ul>
                Get in touch with us today and launch a results-driven PPC
                campaign that delivers real growth.
              </div>
            }
            image={
              <Lottie
                options={{
                  loop: true,
                  autoplay: true,
                  animationData: require("../img/paidads.json"),
                  rendererSettings: {
                    preserveAspectRatio: "xMidYMid slice",
                  },
                }}
                height={state.auth.isMobile ? 350 : 500}
                width={state.auth.isMobile ? 350 : 500}
                isStopped={false}
                isPaused={false}
              />
            }
          />
          <SpacerV height={"100px"} background={dark ? "#111" : "white"} />
          <OurProcess
            process={"Our PPC Process"}
            invert={!dark}
            step1={"Keyword Research and Selection"}
            step1description={
              "We identify high-converting keywords that match user intent. Our research focuses on search volume and competition analysis to increase ad relevance."
            }
            step2={"Ad Creation and Copywriting"}
            step2description={
              "We craft compelling ad copy that attracts potential customers. Every ad is designed for higher engagement and improved quality scores to lower cost per click."
            }
            step3={"Bid Management and Budget Optimization"}
            step3description={
              "We monitor bidding strategies in real time to increase ad placements while maintaining cost efficiency. Our goal is to improve conversions without inflating acquisition costs."
            }
            step4={"Performance Tracking and Refinement"}
            step4description={
              "We analyze click-through rates and conversion data to improve targeting. Audience insights play a major role in refining campaigns for better ROI and sustained profitability."
            }
          />
          <Advantages
            invert={!dark}
            title={"Advantages of Our PPC Advertising Services"}
            title1={"Fast-Track Business Growth"}
            subtitle1={
              "We help brands acquire high-intent leads immediately through paid search and display ads. PPC campaigns offer instant visibility and rapid customer acquisition, making them ideal for businesses looking to scale quickly."
            }
            title2={"Laser-Focused Audience Targeting"}
            subtitle2={
              "We segment audiences based on location and demographics. Search behavior is a key parameter of identifying users most likely to convert."
            }
            title3={"Ad Budget Optimized for ROI"}
            subtitle3={
              "We allocate budgets based on real-time performance and profitability. Underperforming placements are adjusted, and high-converting segments receive more focus, guaranteeing better cost efficiency."
            }
            title4={"Scalable Campaigns for Long-Term Success"}
            subtitle4={
              "We refine bidding models and targeting parameters to keep campaigns profitable. Businesses can increase ad spend without diminishing returns, allowing for continuous expansion."
            }
          />
          <ContentSideBySideInv
            dark={dark}
            title={<h2>PPC Strategies That Deliver Results Core</h2>}
            subtitle="At Riches Media Digital, we take a results-driven approach to PPC advertising. We use competitive insights and A/B testing to refine campaigns. Data-backed decisions help businesses scale profitably and sustain long-term performance. We prioritize ad relevance and audience intent to ensure higher engagement. Every campaign is optimized for cost efficiency and maximum reach across search and display networks. Our structured approach focuses on improving conversion rates through continuous performance analysis."
            image={
              <Lottie
                options={{
                  loop: true,
                  autoplay: true,
                  animationData: require("../img/work2.json"),
                  rendererSettings: {
                    preserveAspectRatio: "xMidYMid slice",
                  },
                }}
                height={state.auth.isMobile ? 350 : 500}
                width={state.auth.isMobile ? 350 : 500}
                isStopped={false}
                isPaused={false}
              />
            }
          />
          <SpacerV height={"100px"} background={dark ? "#111" : "white"} />
          <YouWillGet
            willget={"What PPC Services Will You Get"}
            invert={!dark}
            title1={"Strategic Keyword Targeting"}
            title2={"Higher Click-Through Rates"}
            title3={"Smart Budget Allocation"}
            title4={"Real-Time Campaign Adjustments"}
            title5={"Consistent Sales Growth"}
          />
          <div
            style={{
              display:
                state.auth.isMobile || state.auth.view == "TABP"
                  ? "none"
                  : "block",
            }}
          >
            <Trust invert />
          </div>
          <FAQ2
            invert={!dark}
            q1="What is Pay-Per-Click advertising?"
            a1="Pay-Per-Click (PPC) is a digital advertising model where businesses pay only when someone clicks on their ad. It helps brands reach high-intent users actively searching for their products or services. PPC is widely used in search engine advertising and paid social media campaigns."
            q2="How does PPC benefit businesses?"
            a2="PPC provides immediate visibility on search engines and websites. Businesses use it to generate leads and drive sales quickly without relying solely on organic traffic. It also offers budget control and detailed performance tracking, helping advertisers refine strategies based on real-time data."
            q3="Which platforms are best for PPC?"
            a3="We manage PPC campaigns on Google Ads and Bing Ads for search engine visibility. We also optimize Facebook, LinkedIn, and Instagram ads to help brands engage users on social media. YouTube advertising is another powerful option for businesses looking to increase video-driven conversions."
            q4="How do you track PPC success?"
            a4="We track click-through rates, conversion metrics, and <a href='https://richesmediadigital.com/blog/social-media-marketing-hacks-to-double-your-brand-engagement/'>audience engagement</a> to measure campaign effectiveness. A/B testing helps us analyze which ad variations perform best. Performance dashboards provide detailed insights into cost per click (CPC) and return on ad spend (ROAS) to ensure optimal results."
            q5="How do you reduce PPC costs?"
            a5="We refine keyword bidding strategies and ad targeting to lower advertising expenses. Landing page optimization plays a major role in improving ad quality scores and lowering cost per acquisition (CPA). Eliminating underperforming placements also helps businesses allocate budgets more efficiently."
            q6="How soon can I see results from PPC?"
            a6="PPC generates instant website traffic once the campaign goes live. Many businesses see leads and conversions within hours or days, depending on competition and ad quality. Regular optimization further improves results over time."
          />
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor:
          state.auth.theme == "dark"
            ? themeStyleDark.backgroundColor
            : themeStyle.backgroundColor,
        transition: "opacity 2s",
      }}
    >
      {getContent()}
    </div>
  );
}
